<!-- ipt -->
<template>
  <div class="form_item">
    <span class="form_item_label color_000000">{{ ipt_obj.label }}</span>
    <div :style="{ width: type === 'pc' ? '390px' : '315px' }" class="p_flex">
      <input :class="type === 'pc' ? 'form_item_ipt' : 'form_item_ipt_h5'" class="p_flex1" v-model="value"
        @input="ipt_obj.callback(value)" type="text" />
      <div v-if="ipt_obj.button"
        :class="`${type === 'pc' ? 'form_item_btn' : 'form_item_btn_h5'} ${ipt_obj.isclick && BtnStatus ? 'bg_DC000C' : 'p_no_click'}`"
        class="p_hand border_radius6 color_ffffff font_15 p_text_center" @click="ipt_obj.buttonClick()">
        {{BtnStatus?ipt_obj.button:`${time}s`}}
      </div>
    </div>
    <span class="form_item_error color_DC000C">{{ ipt_obj.error }}</span>
  </div>
</template>
<script>
  export default {
    data() {
      return {
        value: '',
      };
    },
    props: {
      ipt_obj: {
        type: Object
      },
      type: {
        type: String,
        default: 'pc'
      },
      BtnStatus: {
        type: Boolean,
        default: true
      },
      time: {
        type: Number,
        default: 0
      }
    },
    watch: {
      'ipt_obj.value': {
        // 每个属性值发生变化就会调用这个函数
        handler(newVal, oldVal) {
          if (!this.value && this.value !== newVal) {
            this.value = newVal;
          }
        },
        // 立即处理 进入页面就触发
        immediate: true
      }
    },
    created() {

    },
    mounted() {},
    computed: {},
    methods: {

    }
  };
</script>

<style scoped="scoped">
  .form_item_label {
    display: block;
    padding-bottom: 10px;
    font-size: 15px;
  }

  .form_item_ipt {
    font-size: 15px;
    box-sizing: border-box;
    padding: 10px;
    width: 390px;
    height: 60px;
    background: #f6f6f6;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
  }

  .form_item_btn {
    box-sizing: border-box;
    padding: 0 5px;
    min-width: 120px;
    height: 60px;
    line-height: 60px;
    margin-left: 10px;
  }

  .form_item_ipt_h5 {
    font-size: 15px;
    box-sizing: border-box;
    padding: 10px;
    width: 315px;
    height: 50px;
    background: #f6f6f6;
    border-radius: 6px 6px 6px 6px;
    opacity: 1;
  }

  .form_item_btn_h5 {
    box-sizing: border-box;
    min-width: 100px;
    padding: 0 5px;
    height: 50px;
    line-height: 50px;
    margin-left: 10px;
  }

  .form_item_error {
    display: block;
    height: 30px;
    line-height: 30px;
    font-size: 12px;
  }
</style>



// WEBPACK FOOTER //
// src/components/public-input/public-input.vue